(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-personalization')) {
  class BbPersonalization extends HTMLElement {
    static selections = new Map();
    connectedCallback() {
      const key = this.dataset.productId;
      const restore = BbPersonalization.selections.get(key) || {};
      this.querySelectorAll('input,select,textarea').forEach(input => { if (restore[input.name] !== undefined) input.value = restore[input.name]; });
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('input', () => this.remember(key));
      this.addEventListener('change', () => this.remember(key));
    }
    remember(key) {
      const state = {};
      this.querySelectorAll('input,select,textarea').forEach(input => {state[input.name] = input.value;});
      BbPersonalization.selections.set(key,state);
    }
  }
  customElements.define('bb-personalization', BbPersonalization);
}
  } catch(e) { console.error(e); }
})();

})();
